/**
 * Acomax collection tag/group filters — match active Warehouse v1 theme behavior.
 */
(function () {
  function parseSettings(section) {
    try {
      return JSON.parse(section.getAttribute('data-section-settings'));
    } catch (error) {
      return {};
    }
  }

  function getBaseCollectionPath(pathname) {
    const parts = pathname.split('/').filter(Boolean);
    const collectionsIndex = parts.indexOf('collections');

    if (collectionsIndex === -1) {
      return pathname;
    }

    return '/' + parts.slice(0, collectionsIndex + 2).join('/');
  }

  function getTagsFromPath(pathname, basePath) {
    const suffix = pathname.slice(basePath.length).replace(/^\//, '');

    if (!suffix) {
      return [];
    }

    return suffix.split('+').filter(Boolean);
  }

  function updateTagUrl(currentUrl, currentTags, options, hadTags) {
    if (options.isAutomatic) {
      if (currentTags.length === 0) {
        currentUrl.searchParams.delete('constraint');
      } else {
        currentUrl.searchParams.set('constraint', currentTags.join('+'));
      }
      return;
    }

    const tagPath = currentTags.join('+');
    const basePath = getBaseCollectionPath(currentUrl.pathname);
    currentUrl.pathname = tagPath ? `${basePath}/${tagPath}` : basePath;
  }

  function syncTagControls(section, currentTags, options) {
    section.querySelectorAll('[data-tag]').forEach(function (tagElement) {
      const tag = tagElement.getAttribute('data-tag');
      const isActive = currentTags.includes(tag);

      if (tagElement.tagName === 'INPUT') {
        tagElement.checked = isActive;
      }

      tagElement.classList.toggle('is-selected', isActive);
    });

    const mobileDrawer = document.getElementById('mobile-collection-filters');

    if (!mobileDrawer) {
      return;
    }

    const filterCountElement = mobileDrawer.querySelector('.collection-drawer__filter-count');
    const clearButton = mobileDrawer.querySelector('[data-action="clear-tags"]');

    if (filterCountElement) {
      filterCountElement.textContent = `(${currentTags.length})`;
      filterCountElement.style.display = currentTags.length === 0 ? 'none' : 'inline';
    }

    if (clearButton) {
      clearButton.style.display = currentTags.length === 0 ? 'none' : 'block';
    }

    if (options.filterType === 'group') {
      mobileDrawer.querySelectorAll('.collection__filter-item-active').forEach(function (item) {
        const parentList = item.closest('.collection__filter-group');
        const activeDataTag = parentList ? parentList.querySelector('.is-selected[data-tag]') : null;

        if (activeDataTag) {
          item.style.display = 'block';
          item.textContent = activeDataTag.getAttribute('data-tag-user');
        } else {
          item.style.display = 'none';
        }
      });
    }
  }

  function reloadCollection(section, currentUrl, pushState) {
    if (pushState) {
      window.history.pushState({ path: currentUrl.toString() }, '', currentUrl.toString());
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    const sectionId = section.getAttribute('data-section-id');
    const sectionUrl = currentUrl.search
      ? `${currentUrl.pathname}/${currentUrl.search}&section_id=${sectionId}`
      : `${currentUrl.pathname}?section_id=${sectionId}`;

    return fetch(sectionUrl, {
      credentials: 'same-origin',
      method: 'GET',
    }).then(function (response) {
      return response.text().then(function (content) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content;

        const dynamicPart = section.querySelector('.collection__dynamic-part');
        const newDynamicPart = tempElement.querySelector('.collection__dynamic-part');

        if (dynamicPart && newDynamicPart) {
          dynamicPart.innerHTML = newDynamicPart.innerHTML;
        }

        const activeFilters = section.querySelector('.collection__active-filters');
        const newActiveFilters = tempElement.querySelector('.collection__active-filters');

        if (activeFilters && newActiveFilters) {
          activeFilters.innerHTML = newActiveFilters.innerHTML;
        }

        const desktopFilters = section.querySelector('.layout__section--secondary .card');
        const newDesktopFilters = tempElement.querySelector('.layout__section--secondary .card');

        if (desktopFilters && newDesktopFilters) {
          desktopFilters.innerHTML = newDesktopFilters.innerHTML;
        }

        const mobileFilters = document.getElementById('mobile-collection-filters');

        if (mobileFilters) {
          const newMobileFilters = tempElement.querySelector('#mobile-collection-filters');

          if (newMobileFilters) {
            const scrollTop = mobileFilters.querySelector('.collection-drawer__inner')?.scrollTop || 0;
            mobileFilters.innerHTML = newMobileFilters.innerHTML;
            const inner = mobileFilters.querySelector('.collection-drawer__inner');

            if (inner) {
              inner.scrollTop = scrollTop;
            }
          }
        }

        if (window.SPR) {
          window.SPR.initDomEls();
          window.SPR.loadBadges();
        }

        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
    });
  }

  function createController(section) {
    const options = parseSettings(section);

    if (!options.filterType) {
      return null;
    }

    const basePath = getBaseCollectionPath(window.location.pathname);
    let currentTags = getTagsFromPath(window.location.pathname, basePath);
    let currentUrl = new URL(window.location.href);

    if (currentTags.length === 0 && Array.isArray(options.currentTags)) {
      currentTags = options.currentTags.slice();
    }

    function toggleTag(tag) {
      const hadTags = currentTags.length > 0;

      if (currentTags.includes(tag)) {
        currentTags = currentTags.filter(function (value) {
          return value !== tag;
        });
      } else if (options.filterType === 'tag') {
        currentTags = [tag];
      } else {
        const tagGroup = tag.split('_')[0];
        currentTags = currentTags.filter(function (existingTag) {
          return existingTag.split('_')[0] !== tagGroup;
        });
        currentTags.push(tag);
      }

      currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('page');
      updateTagUrl(currentUrl, currentTags, options, hadTags);
      syncTagControls(section, currentTags, options);
      return reloadCollection(section, currentUrl, true);
    }

    function clearTags() {
      const hadTags = currentTags.length > 0;
      currentTags = [];
      currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('page');
      updateTagUrl(currentUrl, currentTags, options, hadTags);
      syncTagControls(section, currentTags, options);

      return reloadCollection(section, currentUrl, true).then(function () {
        document.dispatchEvent(new CustomEvent('collection-filter:close'));
      });
    }

    return {
      toggleTag: toggleTag,
      clearTags: clearTags,
      refreshFromUrl: function () {
        currentUrl = new URL(window.location.href);
        currentTags = getTagsFromPath(currentUrl.pathname, basePath);
        syncTagControls(section, currentTags, options);
      },
    };
  }

  let controllers = new Map();

  function init() {
    document.querySelectorAll('[data-section-type="collection"]').forEach(function (section) {
      const controller = createController(section);

      if (controller) {
        controllers.set(section, controller);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const clearTarget = event.target.closest('[data-action="clear-tags"]');

    if (clearTarget) {
      const section = clearTarget.closest('[data-section-type="collection"]');
      const controller = section ? controllers.get(section) : null;

      if (controller) {
        event.preventDefault();
        controller.clearTags();
      }

      return;
    }

    const target = event.target.closest('[data-action="toggle-tag"]');

    if (!target) {
      return;
    }

    const section = target.closest('[data-section-type="collection"]');
    const controller = section ? controllers.get(section) : null;

    if (!controller) {
      return;
    }

    event.preventDefault();
    controller.toggleTag(target.getAttribute('data-tag'));
  });

  window.addEventListener('popstate', function () {
    controllers.forEach(function (controller) {
      controller.refreshFromUrl();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
